import { HealthStatus } from "../types/log";

export const healthBadgeStyles: Record<HealthStatus, string> = {
  healthy:
    "bg-emerald-500/10 text-emerald-700 dark:bg-emerald-400/15 dark:text-emerald-300",
  unhealthy:
    "bg-amber-500/10 text-amber-700 dark:bg-amber-400/15 dark:text-amber-300",
  critical:
    "bg-rose-500/10 text-rose-700 dark:bg-rose-400/15 dark:text-rose-300",
};

export const healthDotStyles: Record<HealthStatus | "idle", string> = {
  healthy: "bg-emerald-500",
  unhealthy: "bg-amber-500",
  critical: "bg-rose-500",
  idle: "bg-edge-strong",
};

// Left edge bar on log rows and cards, coloured by severity
export const healthBarStyles: Record<HealthStatus, string> = {
  healthy: "bg-emerald-500/70",
  unhealthy: "bg-amber-500",
  critical: "bg-rose-500",
};

export const cardClass =
  "bg-surface rounded-2xl border border-edge shadow-card transition-colors duration-200";

export const cardHoverClass = "hover:border-edge-strong";

export const panelClass = `${cardClass} p-4 sm:p-5 md:p-6`;

export const labelClass = "font-[Gilroy-Medium] text-[12px] text-label-muted";

export const pillClass =
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-[Gilroy-Medium]";

export const primaryButtonClass =
  "inline-flex items-center justify-center gap-2 px-4 sm:px-5 py-2.5 rounded-xl text-sm font-[Gilroy-Medium] text-white bg-accent hover:bg-[#5458e8] transition-colors shadow-glow-sm whitespace-nowrap";

export const secondaryButtonClass =
  "inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-edge bg-surface text-sm font-[Gilroy-Medium] text-heading-color transition-colors hover:border-edge-strong hover:bg-overlay whitespace-nowrap";

export const inputClass =
  "h-11 min-w-0 rounded-xl border border-edge bg-input-bg px-4 font-[Gilroy-Medium] text-[14px] text-heading-color placeholder:text-placeholder outline-none transition-colors hover:border-edge-strong focus:border-accent";
